import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import Incrementer from "../../components/Incrementer/Incrementer";
import "./SelectRooms.css";
import { useSelector } from "react-redux";

const SelectRooms = ({
  setEnablePopup,
  child,
  setChild,
  adults,
  setAdults,
  isHourlyRoom,
  room,
  setRoom,
  fetchOnClick,
  roomsRef,
  dateRange,
  infant,
  setInfant,
}) => {
  const searchRooms = () => {
    fetchOnClick();
    setEnablePopup(false);
  };

  // const { hotelData } = useSelector((state) => state.hotelInfo);

  // console.log({ hotelData });

  const { t } = useTranslation();

  return (
    <div className="selectRooms">
      <div className="selectThings">
        <div className="selectRoomTitle">
          <p>{t("select_guests")} </p>
          <p
            style={{ cursor: "pointer" }}
            onClick={() => {
              searchRooms();
              roomsRef?.current?.scrollIntoView();
            }}
          >
            x
          </p>
        </div>
        <div className="selectRoom">
          <div className="selectRoom__text">
            <div className="selectRoom__textTitle">
              <p>{t("adults")}</p>
              {/* <span>{t("above_12_years_age")}</span> */}
            </div>
          </div>
          <div className="selectRoom__incrementer">
            <Incrementer
              value={adults}
              setValue={setAdults}
              addonName="Adult"
            />
          </div>
        </div>
        <div className="selectRoom">
          <div className="selectRoom__text">
            <div className="selectRoom__textTitle">
              <p>{t("children")}</p>
              {/* <span>{t("below_12_years_age")}</span> */}
            </div>
          </div>
          <div className="selectRoom__incrementer">
            <Incrementer value={child} setValue={setChild} addonName="Child" />
          </div>
        </div>
        <div className="selectRoom">
          <div className="selectRoom__text">
            <div className="selectRoom__textTitle">
              <p>{t("infant")}</p>
              {/* <span>
                ({hotelData?.childAgeSplit}
                {t("years")} - {hotelData?.childAgeLimit}
                {t("years")})
              </span> */}
            </div>
          </div>
          <div className="selectRoom__incrementer">
            <Incrementer
              value={infant}
              setValue={setInfant}
              addonName="Infant"
            />
          </div>
        </div>
        <div className="selectRoom__buttons">
          {!isHourlyRoom && (
            <div className="selectRoom__cancel">
              <span>
                {dayjs(dateRange?.startDate).format("DD MMM")} -{" "}
                {dayjs(dateRange?.endDate).format("DD MMM")}
              </span>
            </div>
          )}
          <div
            className="selectRoom__select"
            onClick={() => {
              searchRooms();
              roomsRef?.current?.scrollIntoView();
            }}
          >
            {t("done")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectRooms;
